export default __webpack_public_path__ + "static/media/student-min.2ce2be16.jpg";